





























































































import { Component, Vue } from "vue-property-decorator";
import AppFooter from "@/components/AppFooter.vue";
import AuthLoginForm from "@/components/AuthLoginForm.vue";

@Component({
  components: { AppFooter, AuthLoginForm }
})
export default class Home extends Vue {
  get lang() {
    return this.$store.state.lang.data;
  }
}
